import { render } from "./CardRit1.vue?vue&type=template&id=58207854&ts=true"
import script from "./CardRit1.vue?vue&type=script&lang=ts"
export * from "./CardRit1.vue?vue&type=script&lang=ts"

import "./CardRit1.vue?vue&type=style&index=0&id=58207854&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__